/**
 * streamlines add a dynamic value to shadow.
 * @param {object} param0
 * @param {string} param0.$shadow
 * @returns {string}
 */
const dynShadow = ({ $shadow }) => {
  if ($shadow === undefined) return "";
  if ($shadow.startsWith("box-shadow") || $shadow.startsWith("filter"))
    return $shadow;
  return `box-shadow: ${$shadow};`;
};

export default dynShadow;
